export default __webpack_public_path__ + "static/media/TwoCars.408a05f8.png";